module.exports = __webpack_public_path__ + "img/img-exercise-walking.d929162c.png";